import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

const selectTripBackupReminderState = (state: RootState) =>
  state.rootReducer.tripBackupReminderReducer;

export const selectTripBackupReminderStatus = createSelector(
  [selectTripBackupReminderState],
  (reminder) => ({
    shouldShow: reminder.shouldShow,
    loading: reminder.loading,
    error: reminder.error,
    lastDismissedAt: reminder.lastDismissedAt,
    lastDownloadedAt: reminder.lastDownloadedAt
  })
);
